import React, { useState } from 'react'
import FilterToolbar, {
  type FilterToolbarField,
} from '@/components/common/FilterToolbar'
import ShowClosedCheckbox from '@/components/Notifications/ShowClosedCheckbox'
import { useRangeLimits } from '@/components/DatePickers/useRangeLimits'
import type { AlertType } from '@/services/notificationService'
import {
  ALERTS_LIST_ANY_TYPE,
  ALERTS_LIST_SEVERITY_OPTIONS,
  buildAlertTypeOptions,
  type AlertsListFilters,
  type AlertsListSeverity,
  type AlertTypesState,
} from './alertsListFilters'

const Filters: React.FC<{
  initial: AlertsListFilters
  onSearch: (filters: AlertsListFilters) => void
  onMoreFilters?: () => void
  alertTypes: AlertType[]
  alertTypesState: AlertTypesState
}> = ({ initial, onSearch, onMoreFilters, alertTypes, alertTypesState }) => {
  const [filters, setFilters] = useState<AlertsListFilters>(initial)

  const clearFilters = () => {
    setFilters(initial)
    onSearch(initial)
  }

  const isFiltered =
    filters.type !== ALERTS_LIST_ANY_TYPE || filters.status !== 'all'

  const limits = useRangeLimits(
    { from: filters.fromDate, to: filters.toDate },
    {}
  )

  const fields: FilterToolbarField[] = [
    {
      name: 'type',
      type: 'select',
      label: 'סוג התראה',
      value: filters.type,
      options: buildAlertTypeOptions(alertTypes, alertTypesState),
      onChange: value => setFilters(current => ({ ...current, type: value })),
    },
    {
      name: 'status',
      type: 'select',
      label: 'חומרה',
      value: filters.status,
      options: ALERTS_LIST_SEVERITY_OPTIONS,
      onChange: value =>
        setFilters(current => ({
          ...current,
          status: value as AlertsListSeverity,
        })),
    },
    {
      name: 'fromDate',
      type: 'date',
      label: 'ת. פתיחה',
      value: filters.fromDate,
      disableFuture: true,
      onChange: value =>
        setFilters(current => ({ ...current, fromDate: value })),
      ...limits.from,
    },
    {
      name: 'toDate',
      type: 'date',
      label: 'ת. שינוי',
      value: filters.toDate,
      disableFuture: true,
      onChange: value => setFilters(current => ({ ...current, toDate: value })),
      ...limits.to,
    },
    {
      name: 'includeClosed',
      type: 'custom',
      render: (
        <ShowClosedCheckbox
          checked={filters.includeClosed}
          onChange={includeClosed => {
            const next = { ...filters, includeClosed }
            setFilters(next)
            onSearch(next)
          }}
        />
      ),
    },
  ]

  return (
    <FilterToolbar
      fields={fields}
      onSearch={() => onSearch(filters)}
      disabled={limits.hasError}
      onClear={isFiltered ? clearFilters : undefined}
      onMoreFilters={onMoreFilters}
    />
  )
}

export default Filters
